export enum SessionTag {
  // Mentor Tags
  EscalatedToMentor = 'escalated-to-mentor',
  LowRating = 'low-rating',

  // Auditor Tags
  NotHelpfulRatings = 'not-helpful-ratings',
  FirstTwoSessions = 'first-two-sessions',
  ManyUnauditedSessions = 'many-unaudited-sessions',
  LowNPSSeries = 'low-nps-series',

  // Safety Tags
  LongOneOnOne = 'long-one-on-one',
  LowEngagement = 'low-engagement-session',
  AIRiskHigh = 'ai-high-risk',

  // Other automated tags
  HighlyEngagingSession = 'highly-engaging-session',
  TutorNoShow = 'tutor-no-show',
  AskQuestions = 'ask-questions',
  PracticeProblems = 'practice-problems',

  // Manually assigned tags
  NotAskingQuestions = 'not-asking-questions',
  PersonalizedGuidance = 'personalized-guidance',
  RelationshipBuilding = 'relationship-building',
  FunEngaging = 'fun-engaging',
  LeveragedTech = 'leveraged-tech',
  GreatExplanations = 'great-explanations',
  TutorOfMonth = 'tutor-of-month',

  // Archived tags
  SummerCamp22Arts = 'summer-camp-22-arts',
  SummerCamp22Writing = 'summer-camp-22-writing',
  SummerCamp22Humanities = 'summer-camp-22-humanities',
  SummerCamp22STEM = 'summer-camp-22-stem',
  SummerCamp22JustForFun = 'summer-camp-22-just-for-fun',
  SummerCamp22Community = 'summer-camp-22-community',
  SummerCamp22Featured = 'summer-camp-22-featured',
  KhanAcademyCrashCourseSummer22 = 'ka-crash-course-summer-22',
  SummerCamp23 = 'summer-camp-23',
  SummerCamp23Featured = 'summer-camp-23-featured',
  SummerCamp2024 = 'summer-camp-2024',
  SummerCamp2024Featured = 'summer-camp-2024-featured',
  RepeatedOneOnOne = 'repeated-one-on-one',
}

export enum SeriesTag {
  HighlyEngagingSATBootcamp = 'high-quality-sat-bootcamp',
  HighlyEngagingCollegeAdmissionsWorkshop = 'highly-engaging-caw-workshop',
  HighlyEngagingAlgebra2LearningLab = 'highly-engaging-algebra2-learning-lab',
  HighlyEngagingPreCalculusLearningLab = 'highly-engaging-pre-calculus-learning-lab',
  SummerCamp2024 = 'summer-camp-2024',
  SummerCamp2024Featured = 'summer-camp-2024-featured',
  SummerCamp2025 = 'summer-camp-2025',
  SummerCamp2025Featured = 'summer-camp-2025-featured',
  FeaturedCommunityEvent = 'featured-community-event',
  ExperimentAIGuideControl = 'experiment-ai-guide-control',
  ExperimentAIGuideExperiment = 'experiment-ai-guide-experiment',
}
